import React from "react"

export function YanoWordmark({ className = "" }) {
  return (
    <span className={`yano-wordmark font-display ${className}`} aria-label="yano">
      <span className="yano-wordmark__ya">ya</span>
      <span className="yano-wordmark__no">no</span>
    </span>
  )
}

export function EditIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" className="h-3.5 w-3.5 fill-none stroke-current stroke-[1.8]">
      <path d="M14.7 3.8a1.7 1.7 0 0 1 2.4 2.4l-8 8-3.6 1.2 1.2-3.6 8-8Z" />
      <path d="m12.8 5.7 1.5 1.5" />
    </svg>
  )
}

export function MicIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" className="h-[1.125rem] w-[1.125rem] fill-none stroke-current stroke-[1.8]">
      <path d="M10 12.6a3 3 0 0 0 3-3V6.4a3 3 0 1 0-6 0v3.2a3 3 0 0 0 3 3Z" />
      <path d="M5 9.8a5 5 0 1 0 10 0" />
      <path d="M10 14.8v2.7" />
      <path d="M7.2 17.5h5.6" />
    </svg>
  )
}

export function VideoIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" className="h-[1.125rem] w-[1.125rem] fill-none stroke-current stroke-[1.8]">
      <rect x="3.2" y="5.3" width="9.3" height="9.4" rx="2.2" />
      <path d="m12.4 8.4 4-2.1v7.4l-4-2.1" />
    </svg>
  )
}

export function VideoOffIcon({ className = "h-7 w-7" }) {
  return (
    <svg aria-hidden="true" viewBox="0 0 24 24" className={`${className} fill-none stroke-current stroke-[1.5]`}>
      <rect x="2" y="6" width="13" height="12" rx="3" />
      <path d="m15 10.5 5-3v9l-5-3" />
      <path d="M2 2 22 22" strokeLinecap="round" />
    </svg>
  )
}

export function CopyIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" className="h-[1.125rem] w-[1.125rem] fill-none stroke-current stroke-[1.8]">
      <rect x="6.6" y="4.2" width="9.2" height="11" rx="2.2" />
      <path d="M4.3 12.9V6.7a2.2 2.2 0 0 1 2.2-2.2h6.4" />
    </svg>
  )
}

export function YanoLogo({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="0 0 200 200" className={className} aria-label="Yano logo">
      <defs>
        <linearGradient id="yano-logo-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f97316" />
          <stop offset="40%" stopColor="#ef4444" />
          <stop offset="100%" stopColor="#c026d3" />
        </linearGradient>
        <linearGradient id="yano-logo-wave" x1="0%" x2="100%">
          <stop offset="0%" stopColor="#818cf8" />
          <stop offset="50%" stopColor="#c084fc" />
          <stop offset="100%" stopColor="#818cf8" />
        </linearGradient>
        <clipPath id="yano-logo-clip">
          <path d="M42,38 Q42,26 54,26 L146,26 Q158,26 158,38 L158,116 Q158,128 146,128 L86,128 L64,150 L70,128 L54,128 Q42,128 42,116 Z" />
        </clipPath>
      </defs>
      <g>
        <animateTransform attributeName="transform" type="translate" values="0,0;0,-2;0,0" dur="3s" repeatCount="indefinite" />
        <path d="M42,38 Q42,26 54,26 L146,26 Q158,26 158,38 L158,116 Q158,128 146,128 L86,128 L64,150 L70,128 L54,128 Q42,128 42,116 Z" fill="url(#yano-logo-grad)" />
        <g clipPath="url(#yano-logo-clip)">
          <polyline fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.85"
            points="30,77 42,77 50,77 58,65 66,89 74,58 82,96 90,48 100,108 110,48 118,96 126,58 134,89 142,65 150,77 160,77 172,77">
            <animate attributeName="points" dur="1.4s" repeatCount="indefinite" values="
              30,77 42,77 50,77 58,65 66,89 74,58 82,96 90,48 100,108 110,48 118,96 126,58 134,89 142,65 150,77 160,77 172,77;
              30,77 42,77 50,72 58,82 66,60 74,94 82,45 90,110 100,38 110,116 118,45 126,94 134,60 142,82 150,72 160,77 172,77;
              30,77 42,77 50,77 58,65 66,89 74,58 82,96 90,48 100,108 110,48 118,96 126,58 134,89 142,65 150,77 160,77 172,77" />
          </polyline>
        </g>
      </g>
    </svg>
  )
}

export function ChatIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" className="h-[1.125rem] w-[1.125rem] fill-none stroke-current stroke-[1.8]">
      <path d="M4.2 5.8A2.6 2.6 0 0 1 6.8 3.2h6.4a2.6 2.6 0 0 1 2.6 2.6v4.5a2.6 2.6 0 0 1-2.6 2.6H9l-3.8 3v-3H6.8a2.6 2.6 0 0 1-2.6-2.6Z" />
      <path d="M7.4 7.6h5.2" />
      <path d="M7.4 10.1h3.8" />
    </svg>
  )
}

export function EffectsIcon() {
  return (
    <svg aria-hidden="true" viewBox="0 0 20 20" className="h-[1.125rem] w-[1.125rem] fill-none stroke-current stroke-[1.8]">
      <path d="M10 2.2l1.1 2.8 2.8 1.1-2.8 1.1L10 10l-1.1-2.8L6.1 6.1l2.8-1.1L10 2.2Z" strokeLinejoin="round" />
      <path d="M15.2 9.2l.7 1.9 1.9.7-1.9.7-.7 1.9-.7-1.9-1.9-.7 1.9-.7.7-1.9Z" strokeLinejoin="round" />
      <path d="M5.2 11.2l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2Z" strokeLinejoin="round" />
    </svg>
  )
}
